// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"735b303aff00a4488f07","655":"514f72415f5f199f74a4"}[chunkId] + ".js";
};